<ng-container *ngIf="searchService.knowledgeBaseResults().length > 0; else noResults">
  <mat-card
    *ngFor="let result of searchService.knowledgeBaseResults()"
    class="my-3 p-2 cursor-pointer"
    (click)="gotoSolution(result)"
  >
    <mat-card-header>
      <mat-card-title class="mb-3">
        {{ result.production_line.name }} - {{ result.workplace.name }} - {{ result.category.name }}
      </mat-card-title>
      <mat-card-subtitle>
        {{ result.malfunction.name }} - {{ result.solution.name }}

      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>

      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column">

          <div class="card-text"></div>
          <div class="card-text">{{
                  result.solution.description | removeHtmlAndTruncate:30
            }}
          </div>
        </div>
        <div class="select-icon"><i class="bi bi-chevron-right"></i></div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-template #noResults>
  <mat-card class="my-3 p-2">
    <mat-card-header>
      <mat-card-title class="mb-3">Keine Suchergebnisse gefunden</mat-card-title>
      <mat-card-subtitle>Zu Ihrem Suchbegriff wurden keine Lösungsvorgänge gefunden</mat-card-subtitle>
    </mat-card-header>
  </mat-card>
</ng-template>
